import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISession } from '../../models/session-group/session.model';
import { LocalizedDatePipe } from '../../pipes/localized-date.pipe';
import { LocationNamePipe } from '../../pipes/location-name.pipe';
import { SessionFormat } from '../../enums/session-group/session-formats.enum';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-session-info-icons',
  standalone: true,
  imports: [CommonModule, LocalizedDatePipe, LocationNamePipe, TranslateModule],
  templateUrl: './session-info-icons.component.html',
  styleUrls: ['./session-info-icons.component.scss']
})
export class SessionInfoIconsComponent implements OnInit {
  SessionFormat = SessionFormat;

  @Input() session: {
    index: number;
    startAt: string | Date;
    endAt: string | Date;
    format: SessionFormat;
    location: {
      title: string;
      internalTitle: string | null;
    } | null;
  } | undefined;
  @Input() showDate: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
